import { render, staticRenderFns } from "./FormElementSwitch.vue?vue&type=template&id=25c623fa"
import script from "./FormElementSwitch.vue?vue&type=script&lang=js"
export * from "./FormElementSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports